module.exports = "data:image/gif;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICIuLi9pbWcvbmVtc2lzLmdpZiI7"


//////////////////
// WEBPACK FOOTER
// ./src/_assets/img/nemsis.gif
// module id = 40
// module chunks = 0